import React from 'react';
import {useIntl} from 'react-intl';
import {useSelector} from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {HiOutlineChartBar} from '@react-icons/all-files/hi/HiOutlineChartBar';
import isEmpty from 'lodash.isempty';
import {EmptyState} from '@components/shared/EmptyState';
import {Skeleton} from '@components/shared/Skeleton';
import {selectSenderSummary} from '../../reportsSlice';
import Row from './Row/Row';
import {TRANSACTION_SUMMARY_STATUSES} from '../../../../../constants';
import MobileRow from './Row/MobileRow';
import './sendersSummary.less';

const SKELETON_ROW_COUNT = 4;

export default function SendersSummary({startDate, endDate, isFetching = false}) {
    const intl = useIntl();
    const sendersSummary = useSelector(selectSenderSummary);
    const hasResults = !isEmpty(sendersSummary);

    function renderSkeletonRows() {
        return Array.from({length: SKELETON_ROW_COUNT}).map((_, index) => (
            <TableRow key={`skeleton-${index}`} className="senders-summary-skeleton-row">
                <TableCell align="left">
                    <Skeleton variant="text" width="60%" />
                </TableCell>
                {TRANSACTION_SUMMARY_STATUSES.map((status) => (
                    <TableCell align="left" key={`skeleton-${index}-${status}`}>
                        <Skeleton variant="text" width="40%" />
                    </TableCell>
                ))}
            </TableRow>
        ));
    }

    function renderMobileSkeletons() {
        return Array.from({length: SKELETON_ROW_COUNT}).map((_, index) => (
            <div key={`mobile-skeleton-${index}`} className="sender-summary-mobile-skeleton">
                <Skeleton variant="text" width="50%" />
                <Skeleton variant="text" width="80%" />
            </div>
        ));
    }

    return (
        <div className="senders-summary">
            <Table classes={{root: 'senders-summary-table'}}>
                <TableHead>
                    <TableRow>
                        <TableCell align="left">
                            {intl.formatMessage({id: 'esl.generic.sender', defaultMessage: ''})}
                        </TableCell>
                        {TRANSACTION_SUMMARY_STATUSES.map((status) => (
                            <TableCell align="left" key={status}>
                                {intl.formatMessage({id: `esl.package.status.${status}`, defaultMessage: ''})}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isFetching && !hasResults && renderSkeletonRows()}
                    {!isFetching && hasResults && sendersSummary.map((senderSummary) => (
                        <Row
                            senderSummary={senderSummary}
                            startDate={startDate}
                            endDate={endDate}
                            key={senderSummary?.sender?.id}
                        />
                    ))}
                    {!isFetching && !hasResults && (
                        <TableRow classes={{root: 'summary-empty-row'}}>
                            <TableCell colSpan={TRANSACTION_SUMMARY_STATUSES.length + 1} align="center">
                                <EmptyState
                                    icon={<HiOutlineChartBar />}
                                    title={intl.formatMessage({id: 'esl.reports.empty_title', defaultMessage: 'No report yet'})}
                                    description={intl.formatMessage({id: 'esl.partials.reports.select_before_submit', defaultMessage: ''})}
                                    size="sm"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            <div className="mobile-list">
                {isFetching && !hasResults && renderMobileSkeletons()}
                {!isFetching && hasResults && sendersSummary.map((senderSummary) => (
                    <MobileRow
                        senderSummary={senderSummary}
                        startDate={startDate}
                        endDate={endDate}
                        key={senderSummary?.sender?.id}
                    />
                ))}
                {!isFetching && !hasResults && (
                    <EmptyState
                        icon={<HiOutlineChartBar />}
                        title={intl.formatMessage({id: 'esl.reports.empty_title', defaultMessage: 'No report yet'})}
                        description={intl.formatMessage({id: 'esl.partials.reports.select_before_submit', defaultMessage: ''})}
                        size="sm"
                    />
                )}
            </div>
        </div>
    );
}
